// import { create } from 'zustand';

// export const useAuthStore = create((set) => ({
//   user: null,
//   isAuthenticated: false,
//   setUser: (user) => set({ user, isAuthenticated: !!user }),
//   updateUser: (userData) => set((state) => ({
//     user: { ...state.user, ...userData }
//   })),
//   logout: () => set({ user: null, isAuthenticated: false }),
// }));

import { create } from "zustand";
import axios from "axios";
import { useEffect } from "react";


// Zustand store to manage auth state
export const useAuthStore = create((set) => ({
  user: null,
  token: "",
  isAuthenticated: false,  // ✅ Boolean value, not a function

  setAuth: (authData) => {
    // ✅ Update Zustand state
    set({
      user: authData.user,
      token: authData.token,
      isAuthenticated: !!authData.user,
    });

    // ✅ Update axios headers
    if (authData.token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${authData.token}`;
    }

    // ✅ Save to localStorage for persistence
    localStorage.setItem("auth", JSON.stringify(authData));
  },

  updateUser: (userData) =>
  set((state) => {
    const updatedUser = { ...state.user, ...userData };
    const updatedAuth = {
      user: updatedUser,
      token: state.token,
    };
    localStorage.setItem("auth", JSON.stringify(updatedAuth));
    return { user: updatedUser };
  }),


  logout: () => {
    // ✅ Clear Zustand state
    set({ user: null, token: "", isAuthenticated: false });

    // ✅ Clear axios headers
    delete axios.defaults.headers.common["Authorization"];

    // ✅ Remove from localStorage
    localStorage.removeItem("auth");
    localStorage.removeItem("academiaHubToken");
    localStorage.removeItem("academiahub_sessions");
    localStorage.removeItem("academiahub_user");
    localStorage.removeItem("academiahub_teachers");
    localStorage.removeItem("currentUser");

    // ✅ Redirect to login
    window.location.href = "/login";

  },
}));

// ✅ Load Auth Data from localStorage on App Start
export const usePersistedAuth = () => {
  const { setAuth } = useAuthStore();

  useEffect(() => {
    const storedAuth = localStorage.getItem("auth");
    if (storedAuth) {
      const parsedAuth = JSON.parse(storedAuth);
      setAuth(parsedAuth); // ✅ Set Zustand store from localStorage
    }
  }, [setAuth]);

  return null; // No UI rendering
};

// export { usePersistedAuth, use };
